module.exports = __webpack_public_path__ + "media/images/favicon/www.franchienergia.ch-d2f694b2474d5ddf1ef3c89b8896a693.webmanifest";